module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"latest news":"News"},"de":{"latest news":"aktuelle Nachrichten"}}')
  delete Component.options._Ctor
}
